const getError = (state) => state.get('error');

export const getErrorAction = (state) => getError(state).get('action');
export const getErrorMessage = (state) => getError(state).get('message');
export const getErrorType = (state) => getError(state).get('type');
export const getErrorIsOpened = (state) => getError(state).get('isOpened');
